import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { cn } from '@discover-lib/utils';

export type CommandRootProps = ComponentPropsWithoutRef<typeof CommandPrimitive>;

const CommandRoot = forwardRef<ElementRef<typeof CommandPrimitive>, CommandRootProps>(
  ({ className, ...props }, ref) => (
    <CommandPrimitive
      ref={ref}
      className={cn(
        'flex flex-col overflow-hidden rounded-md bg-popover text-popover-foreground',
        className
      )}
      {...props}
    />
  )
);

CommandRoot.displayName = CommandPrimitive.displayName;

export default CommandRoot;
